export const ActionTypes = {
	SET_PRODUCTS: "SET_PRODUCTS",
	SELECTED_PRODUCT: "SELECTED_PRODUCT",
	REMOVE_SELECTED_PRODUCT: "REMOVE_SELECTED_PRODUCT",
	ADD_PRODUCT: "ADD_PRODUCT",
	SUBTRACT_PRODUCT: "SUBTRACT_PRODUCT",
	ADD_TO_CART: "ADD_TO_CART",
	SUBTRACT_FROM_CART: "SUBTRACT_FROM_CART",
};
